<template>
  <el-dropdown trigger="click" :hide-on-click="false" @command="handleCommand" :style="{ width: getStyle.width }" class="dropdown-v2" @visible-change="visibleChange">
    <div class="select-v2 select-multiple-v2 is-multiple pointer">
      <div class="el-select" :style="{ width: getStyle.width }">
        <div class="el-select__tags" :style="{ width: '100%', 'max-width': getStyle.maxWidth }">
          <span>
            <span class="el-tag el-tag--info el-tag--small el-tag--light" v-if="checkedData.data.length > 0">
              <span class="el-select__tags-text">{{ checkedDataFirst[keyProps.label] }}</span>
              <i class="el-tag__close el-icon-close" @click.stop="removeTag"></i>
            </span>
            <span class="el-tag el-tag--info el-tag--small el-tag--light" v-if="checkedData.data.length > 1">
              <span class="el-select__tags-text">+{{ checkedData.data.length - 1 }}</span>
            </span>
          </span>
        </div>
        <div class="el-input el-input--prefix el-input--suffix">
          <input type="text" readonly="readonly" autocomplete="off" :placeholder="!checkedData.data.length ? $t('logon.selectCustomer') : ''" class="el-input__inner">
          <span class="el-input__prefix">
            <i class="el-icon-search color-primary font-16"></i>
          </span>
          <span class="el-input__suffix">
            <span class="el-input__suffix-inner">
              <i class="el-select__caret el-input__icon el-icon-arrow-up" :class="{ 'is-reverse': isVisible }"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
    <el-dropdown-menu slot="dropdown" class="el-dropdown-menu-v2-multiple" :style="{ width: getStyle.width }">
      <div class="input-v2 mb6">
        <el-input v-model="keywords" placeholder="请输入关键字" prefix-icon="el-icon-search" maxlength="30" clearable></el-input>
      </div>
      <div class="dropdown-item-list" :style="{ maxHeight: getStyle.maxHeight, overflow: 'auto' }">
        <el-dropdown-item v-for="item in filterOptions" :key="item[keyProps.value]" :icon="getIcon(item)" :command="item">
          <span class="el-dropdown-menu__item_label" :class="{ bold: item.isMaster == 1 }" style="display: inline-block; width: calc(100% - 20px)">{{item[keyProps.label]}}</span>
        </el-dropdown-item>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import { validatenull } from "@/util/validate";
  export default {
    name: "CustomSelectMultiple",
    props: {
      options: {
        type: Array,
        default() {
          return []
        }
      },
      keyProps: {
        type: Object,
        default() {
          return {
            label: 'label',
            value: 'value'
          }
        }
      },
      width: {
        type: [String, Number],
        default: '250px'
      }
    },
    data() {
     return {
       list: this.options,
       isVisible: false,
       keywords: ''
     }
    },
    methods: {
      // 设置下拉复选框图标
      getIcon(command) {
        let iconName = 'el-icon-empty';
        if (command.isMaster == 1) {
          if (command.checked) {
            iconName = 'el-icon-check';
          } else if (this.isEmpty) {
          } else {
            iconName = 'el-icon-minus';
          }
        } else {
          iconName = command.checked ? 'el-icon-check' : 'el-icon-empty';
        }
        return iconName;
      },
      // 设置全选反选
      setCheckAll() {
        const index = this.options.findIndex(item => item.isMaster == 1);
        this.$set(this.options[index], 'checked', this.checkedData.isCheckAll);
      },
      // 下拉选中事件
      handleCommand(command) {
        const checked = !command.checked;
        if (command.isMaster == 1) {
          this.options.forEach(item => {
            this.$set(item, 'checked', checked);
          })
        } else {
          this.$set(command, 'checked', !command.checked);
          this.setCheckAll();
        }
        this.$emit('change', this.checkedData);
      },
      // 批量选中方法
      handleBatchCommand(ids) {
        this.options.forEach(item => {
          if (ids.includes(item[this.keyProps.value])) {
            this.$set(item, 'checked', true);
          } else {
            this.$set(item, 'checked', false);
          }
        })
        this.$emit('change', this.checkedData);
      },
      // 删除选中项，删除第一个
      removeTag() {
        this.checkedDataFirst.checked = false;
      },
      // 监测下拉框出现/隐藏
      visibleChange(val) {
        this.isVisible = val;
        this.keywords = ''
      }
    },
    computed: {
      // 是否全选
      checkedData() {
        const checked = this.options.filter(item => item.isMaster != 1&& item.checked);
        const checkedLabels = checked.map(item => item[this.keyProps.label]);
        const checkedValues = checked.map(item => item[this.keyProps.value]);
        return {
          data: checked,
          checkedLabels,
          checkedValues,
          isCheckAll: checked.length === this.options.length - 1
        }
      },
      // 获取第一个选中的数据
      checkedDataFirst() {
        return this.checkedData.data.length ? this.checkedData.data[0] : {};
      },
      // 是否全部不选
      isEmpty() {
        const checked = this.options.filter(item => item.isMaster != 1 && item.checked);
        return checked.length === 0;
      },
      getStyle() {
        let width = '';
        let maxWidth = '';
        if (typeof this.width == 'string') {
          width = this.width;
        }
        if (typeof this.width == 'number') {
          width = this.width + 'px';
        }
        maxWidth = `calc(${ this.width } + 50px)`;
        return {
          width,
          maxWidth,
          maxHeight: '500px'
        }
      },
      filterOptions() {
        if(validatenull(this.keywords)) {
          return this.options
        } else {
          return this.options.filter(item => item[this.keyProps.label].includes(this.keywords))
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
